/**
 * Mirrors packages/amgbandarqq_v2/lib/presentation/rive/rive_inputs.dart.
 */

/** Main artboard, "Main" state machine — top bar / girl / bet click triggers. */
export const BandarMainInputs = {
  trigEndBet: 'triRedTab1',
  trigStartBet: 'triRedTab2',
  boolIsSingleMode: 'isSingleMode',
  boolIsSoundOn: 'isSoundOn',
  numGirl: 'Girl', // 0=idle, 1=letsPlay, 2=takeChip
  trigBetClick: (i: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): string => `BetClick${i}`,
} as const;

/** Main artboard, "MainBetResult" state machine — yellow box winner highlights. */
export const BandarResultInputs = {
  boolYellowBox: (i: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): string =>
    `BoolyellowBox${i}`,
  boolResultWinAmount: (i: 1 | 2 | 3 | 4 | 5 | 6): string =>
    `boolResultWinAmount${i}`,
} as const;

/** topItem artboard, "Effect" state machine — dominoes / VS / sparkles. */
export const BandarEffectInputs = {
  numWinningAward: 'winningAward',
  boolIsSoundOn: 'isSoundOn',
  numResetDominoRandom: 'resetDominoRandom',
  numIntLightBox: 'intLightBox',
  trigResetResult: 'resetResult',
  boolVS: 'BoolVS',
  numQuiTwinTop: 'intQuiTwinTop',
  numQuiTwin: 'intQuiTwin',
  numSaberBox: 'intSaberBox',
  numDomino1: 'domino1',
  numDomino2: 'domino2',
  numDomino3: 'domino3',
  numDomino4: 'domino4',
} as const;

/** Text-run names exposed across artboards. */
export const TextInputs = {
  balance: 'txtRCoinAmount',
  betAmount: 'txtBetAmount',
  winAmount: 'txtWinAmount',
  minBet: 'txtMinValue',
  maxBet: 'txtMaxValue',
} as const;

export const RiveEventNames = {
  placeBetClick: 'placeBetClick',
  evtClickChips: 'evtClickChips',
  evtClearClick: 'evtClearClick',
  evtButtonPlayClick: 'evtButtonPlayClick',
  uiButtonClick: 'UIButtonClick',
  evtResultStop: 'evtResultStop',
  evtYouWinEnd: 'evtYouWinEnd',
  evtYouLoseEnd: 'evtYouLoseEnd',
} as const;
